export enum Hotkeys {
    playPause = 179,
    spaceBar = 32,
    left = 37,
    previous = 177,
    up = 38,
    down = 40,
    m = 77,
    f = 70,
}
